import axios from "axios";
import { useState } from "react";
import cookieStorage from "../../cookieStorage";
import { API_ENDPOINT, getAuthHeaders, customerInflight } from "./shared";

export default function useAuthApi() {
    const [customer, setCustomer] = useState({});
    const [customerRewardItem, setCustomerRewardItem] = useState();
    const [newsletter, setNewsletter] = useState({});

    const [rewards, setRewards] = useState(
        cookieStorage.getItem("rewards")
            ? JSON.parse(cookieStorage.getItem("rewards"))
            : []
    );
    const [rewardsThreshold, setRewardsThreshold] = useState(
        cookieStorage.getItem("rewardsThreshold")
            ? JSON.parse(cookieStorage.getItem("rewardsThreshold"))
            : null
    );
    const [userId, setUserId] = useState(
        cookieStorage.getItem("userId") ? cookieStorage.getItem("userId") : null
    );
    const [priceClass, setPriceClass] = useState(
        cookieStorage.getItem("priceClass")
            ? cookieStorage.getItem("priceClass")
            : null
    );
    const [priceid, setPriceid] = useState(
        cookieStorage.getItem("priceid") ? cookieStorage.getItem("priceid") : null
    );
    const [customerId, setCustomerId] = useState(
        cookieStorage.getItem("customerId")
            ? cookieStorage.getItem("customerId")
            : null
    );
    const [accessToken, setAccessToken] = useState(
        cookieStorage.getItem("accessToken")
            ? cookieStorage.getItem("accessToken")
            : null
    );
    const [isAdmin, setIsAdmin] = useState(
        cookieStorage.getItem("isAdmin")
            ? cookieStorage.getItem("isAdmin")
            : false
    );
    const [firstLogin, setFirstLogin] = useState(
        cookieStorage.getItem("firstLogin")
            ? JSON.parse(cookieStorage.getItem("firstLogin"))
            : false
    );
    const [childCustomers, setChildCustomers] = useState(
        cookieStorage.getItem("childCustomers")
            ? JSON.parse(cookieStorage.getItem("childCustomers"))
            : []
    );
    const [multipleCustomers, setMultipleCustomers] = useState(false);

    return {
        customer,
        customerRewardItem,
        setCustomerRewardItem,
        rewards,
        rewardsThreshold,
        userId,
        priceClass,
        priceid,
        customerId,
        setCustomerId,
        accessToken,
        isAdmin,
        firstLogin,
        setFirstLogin,
        childCustomers,
        multipleCustomers,
        setMultipleCustomers,
        newsletter,

        login(data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/auth/login`, data)
                    .then((response) => {
                        resolve(response.data);
                        setUserId(response.data._id);
                        setAccessToken(response.data.accessToken);
                        setCustomerId(response.data.customerId);
                        if (response.data.childCustomers.length > 0) {
                            setCustomerId(
                                response.data.childCustomers[0].customerId
                            );
                        }
                        setIsAdmin(response.data.isAdmin);
                        setCustomer(response.data.customer);
                        setPriceClass(response.data.customer.PriceClassID);
                        setPriceid(response.data.customerId);
                        setFirstLogin(true);
                        setRewards(response.data.rewards);
                        setChildCustomers(response.data.childCustomers);
                        if (response.data.customerRewardsThreshold) {
                            const formattedData = {
                                threshold1:
                                    response.data.customerRewardsThreshold
                                        .Threshold1.value,
                                threshold2:
                                    response.data.customerRewardsThreshold
                                        .Threshold2.value,
                                threshold3:
                                    response.data.customerRewardsThreshold
                                        .Threshold3.value
                            };
                            setRewardsThreshold(formattedData);
                            cookieStorage.setItem(
                                "rewardsThreshold",
                                JSON.stringify(formattedData)
                            );
                        } else {
                            cookieStorage.setItem("rewardsThreshold", null);
                        }

                        cookieStorage.setItem("userId", response.data._id);
                        cookieStorage.setItem(
                            "accessToken",
                            response.data.accessToken
                        );
                        cookieStorage.setItem(
                            "customerId",
                            response.data.customerId
                        );
                        cookieStorage.setItem(
                            "rewards",
                            JSON.stringify(response.data.rewards)
                        );
                        if (response.data.childCustomers.length > 0) {
                            cookieStorage.setItem(
                                "customerId",
                                response.data.childCustomers[0].customerId
                            );
                        }
                        cookieStorage.setItem("isAdmin", response.data.isAdmin);
                        cookieStorage.setItem(
                            "priceClass",
                            response.data.customer.PriceClassID
                        );
                        cookieStorage.setItem(
                            "priceid",
                            response.data.customerId
                        );
                        cookieStorage.setItem("firstLogin", true);
                        cookieStorage.setItem(
                            "childCustomers",
                            JSON.stringify(response.data.childCustomers)
                        );
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        logout() {
            return new Promise((res) => {
                // Clear state variables to prevent background tasks from re-populating cookies
                setUserId(null);
                setAccessToken(null);
                setCustomerId(null);
                setPriceClass(null);
                setPriceid(null);
                setIsAdmin(false);
                setCustomer({});
                setChildCustomers([]);
                setRewards([]);
                setRewardsThreshold(null);
                setFirstLogin(false);

                // Clear all persistent storage
                cookieStorage.removeItem("userId");
                cookieStorage.removeItem("accessToken");
                cookieStorage.removeItem("isAdmin");
                cookieStorage.removeItem("priceClass");
                cookieStorage.removeItem("priceid");
                cookieStorage.removeItem("rewardsThreshold");
                cookieStorage.removeItem("countdownTime");
                cookieStorage.removeItem("customerId");
                cookieStorage.removeItem("isTileView");
                cookieStorage.removeItem("firstLogin");
                cookieStorage.removeItem("childCustomers");
                cookieStorage.removeItem("rewards");

                res();
            });
        },
        register(data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/auth/register`, data)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        forgot(data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/auth/forgot`, data)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        request(data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/auth/request`, data)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        getCustomer(id) {
            if (!id) {
                return Promise.reject(new Error("Missing customer id"));
            }

            // Return in-memory customer when already loaded for this id
            if (
                customer &&
                Object.keys(customer).length > 0 &&
                String(priceid) === String(id)
            ) {
                return Promise.resolve({
                    customer,
                    rewards,
                    isAdmin,
                    customerRewardsThreshold: rewardsThreshold
                        ? {
                              Threshold1: { value: rewardsThreshold.threshold1 },
                              Threshold2: { value: rewardsThreshold.threshold2 },
                              Threshold3: { value: rewardsThreshold.threshold3 }
                          }
                        : null
                });
            }

            if (customerInflight.has(id)) {
                return customerInflight.get(id);
            }

            const promise = new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/customers/${id}`, {
                        headers: getAuthHeaders()
                    })
                    .then((response) => {
                        const customerData = response.data.customer || {};
                        const shippingZoneId = typeof customerData.ShippingZoneID === "string"
                            ? customerData.ShippingZoneID
                            : customerData.ShippingZoneID?.value || "";
                        const normalizedCustomer = {
                            ...customerData,
                            ShippingZoneID: shippingZoneId
                        };
                        const normalizedResponse = {
                            ...response.data,
                            customer: normalizedCustomer
                        };

                        resolve(normalizedResponse);
                        setCustomer(normalizedCustomer);
                        setRewards(response.data.rewards);
                        setIsAdmin(response.data.isAdmin);

                        setPriceid(id);
                        if (response.data.customerRewardsThreshold) {
                            const formattedData = {
                                threshold1:
                                    response.data.customerRewardsThreshold
                                        .Threshold1.value,
                                threshold2:
                                    response.data.customerRewardsThreshold
                                        .Threshold2.value,
                                threshold3:
                                    response.data.customerRewardsThreshold
                                        .Threshold3.value
                            };
                            setRewardsThreshold(formattedData);
                            cookieStorage.setItem(
                                "rewardsThreshold",
                                JSON.stringify(formattedData)
                            );
                            cookieStorage.setItem(
                                "rewards",
                                JSON.stringify(response.data.rewards)
                            );
                        } else {
                            setRewardsThreshold(null);
                            cookieStorage.setItem("rewardsThreshold", null);
                        }
                    })
                    .catch((error) => {
                        reject(error.response);
                    })
                    .finally(() => {
                        customerInflight.delete(id);
                    });
            });

            customerInflight.set(id, promise);
            return promise;
        },
        updateCustomer(id, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`${API_ENDPOINT}/auth/update-profile/${id}`, data, {
                        headers: getAuthHeaders()
                    })
                    .then((response) => {
                        resolve(response.data);
                        if (response.data.customer) {
                            setCustomer(response.data.customer);
                        }
                    })
                    .catch((error) => {
                        reject(error.response?.data || error);
                    });
            });
        },
        updatePassword(id, passwordData) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        `${API_ENDPOINT}/auth/change-password/${id}`,
                        passwordData,
                        { headers: getAuthHeaders() }
                    )
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response?.data || error);
                    });
            });
        },
        resetPassword(passwordData) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/auth/reset-password`, passwordData)
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response?.data || error);
                    });
            });
        },
        getCustomerRewards() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/rewards?customerId=${customerId}`, {
                        headers: getAuthHeaders()
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        getNewsletter() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${API_ENDPOINT}/newsletter`, {
                        headers: getAuthHeaders()
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        updateNewsletter(data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${API_ENDPOINT}/newsletter`, data, {
                        headers: getAuthHeaders()
                    })
                    .then((response) => {
                        resolve(response.data);
                        setNewsletter(response.data.updatedNewsletter.banners);
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        }
    };
}
